<template>
    <header>
        <div>
            <b-navbar class="menu" toggleable="md" type="dark" >
                <b-navbar-brand @click="goRouter('/')" class="cursor-pointer"><img class="logo" src="@/assets/logo.svg" alt="Logo img"></b-navbar-brand>

                <b-navbar-toggle target="" v-b-toggle.sidebar-right id="nav-ocult"></b-navbar-toggle>

                <b-navbar-toggle target="nav-collapse" toggleable="md" id="nav-normal"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                        <b-navbar-nav right class="mr-0">
                            <b-nav-item class="mr-4 ml-4 menu-font" @click="goRouter('/')">Inicio</b-nav-item>
                            <b-nav-item class="mr-4 ml-4 menu-font" @click="goRouter('/usuario')">Soy cliente</b-nav-item>
                        </b-navbar-nav>
                        <b-nav-item-dropdown class="mr-4 ml-4 menu-font" style="text-align: left;" text="Soy Negocio" right>
                            <b-dropdown-item @click="redirectToBusinessApp()">Iniciar sesión</b-dropdown-item>
                            <b-dropdown-item @click="goRouter('/negocio')">Cómo funciona</b-dropdown-item>
                            <b-dropdown-item @click="goRouter('/contacto')">Quiero ser GOX</b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-navbar-nav class="mr-0" >
                            <b-nav-item class="mr-4 ml-4 menu-font" @click="goRouter('/nosotros')">Quienes Somos</b-nav-item>
                        </b-navbar-nav>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
            
            <b-sidebar id="sidebar-right" title="" bg-variant="black"  right shadow >
                <div class="px-3 py-2">
                    <b-navbar-nav class="ml-auto">
                        <b-navbar-nav right class="mr-0">
                            <b-nav-item class="mr-4 ml-4 menu-font" @click="goRouter('/')">Inicio</b-nav-item>
                            <b-nav-item class="mr-4 ml-4 menu-font" @click="goRouter('/usuario')">Soy cliente</b-nav-item>
                        
                        <!--<b-nav-item-dropdown class="mr-4 ml-4 menu-font" style="text-align: left; color: white;" text="Soy Negocio" right>
                            <b-dropdown-item @click="goRouter('/sesion')">Iniciar sesión</b-dropdown-item>
                            <b-dropdown-item @click="goRouter('/negocio')">Cómo funciona</b-dropdown-item>
                            <b-dropdown-item @click="goRouter('/contacto')">Quiero ser GOX</b-dropdown-item>
                        </b-nav-item-dropdown>-->
                        
                            <b-nav-item class="mr-4 ml-4 menu-font">Soy Negocio</b-nav-item>
                            <b-nav-item class="ml-4" @click="redirectToBusinessApp()">Iniciar sesión</b-nav-item>
                            <b-nav-item class="ml-4" @click="goRouter('/negocio')">Cómo funciona</b-nav-item>
                            <b-nav-item class="ml-4" @click="goRouter('/contacto')">Quiero ser GOX</b-nav-item>
                        </b-navbar-nav>
                        <b-navbar-nav class="mr-0" >
                            <b-nav-item class="mr-4 ml-4 menu-font" @click="goRouter('/nosotros')">Quienes Somos</b-nav-item>
                        </b-navbar-nav>
                    </b-navbar-nav>
                </div>

                <template #footer>
                    <div class="footer-nav">
                        <div  @click="goRouter('/')" class="cursor-pointer div-logo-nav-footer"><img class="logo-nav-footer" src="@/assets/logo.svg" alt="Logo img"></div>
                        <div class="h2 icons-footer-nav">
                            <b-icon icon="facebook" style="width: 40px; height: 40px; color: black;"></b-icon>
                            <b-icon icon="instagram" style="width: 40px; height: 40px; color: black;"></b-icon>
                        </div>
                    </div>
                </template>
            </b-sidebar>
        </div>
    </header>
</template>
<script>

    import configs from '../local_config'

    export default {
        name: 'Navbar',
        methods: {
            goRouter(url) {
                this.$router.push(url)
            },
            redirectToBusinessApp() {
                location.href = `${configs.GOX_NEGOCIOS_LOGIN_URL}`
            }
        }
    }
</script>
<style scoped>





#nav-ocult {
    display: none;
  }

#sidebar-right{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.footer-nav {
    display: flex;
    width: 100%;
    height: 100px;
    background-color: white;
    justify-content: space-around;
}

#footer {
    background-color: white !important;
    display: flex;
}
.div-logo-nav-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px
}
.logo-nav-footer {
    height: 80px;
}

.icons-footer-nav {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 120px;

}
.navbar-nav .nav-link {
    color: white !important;
}



.b-sidebar > .b-sidebar-header .close {
    font-size: 2.5rem !important;
    color: white !important;
    
}


.b-icon.bi {
    color: white !important;
}



#footer{
    background-color: white;
}



@media (max-width: 600px) {

  .navbar {
    height: 100px;
  }

  #nav-normal {
    display: none;
  }

  #nav-ocult {
    display: flex;
  }
}

</style>